import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'plainDecimal'
})
export class PlainDecimalPipe implements PipeTransform {
    transform(value: any, decimalPlaces: number = 2): string {
        const num = parseFloat(value);
        if (isNaN(num)) return '';
        return num.toFixed(decimalPlaces);
    }
}
